import { render, staticRenderFns } from "./EditClaimParametersModal.vue?vue&type=template&id=0a91a2b5&scoped=true&"
import script from "./EditClaimParametersModal.vue?vue&type=script&lang=js&"
export * from "./EditClaimParametersModal.vue?vue&type=script&lang=js&"
import style0 from "./EditClaimParametersModal.vue?vue&type=style&index=0&id=0a91a2b5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a91a2b5",
  null
  
)

export default component.exports